import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import { useDataValue } from 'Simple/Data'

import mutationMarkAllNotificationsRead from './mutation-mark-all-notifications-read.graphql.js'
import mutationMarkNotificationRead from './mutation-mark-notification-read.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutationMarkAllNotificationsRead] = useMutation(
    mutationMarkAllNotificationsRead
  )
  let [, executeMutationMarkNotificationRead] = useMutation(
    mutationMarkNotificationRead
  )

  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'mark-as-read': {
        let { error } = await executeMutationMarkNotificationRead({
          id: args.value.id,
        })

        if (error) {
          notify(notifyError('Cannot mark as read due to an error'))
          return
        }

        return
      }

      case 'mark-all-as-read': {
        let { error } = await executeMutationMarkAllNotificationsRead({
          user_id,
        })

        if (error) {
          notify(notifyError('Cannot mark all as read due to an error'))
          return
        }
        return
      }

      default: {
      }
    }
  }
}
